import React from 'react';

// Partner names rendered as text chips — swap for logo images when assets are available.
const PARTNERS = ['YFM Equity Partners', 'SolidBond', 'Northstar Ventures', 'ACF Investors', 'Key Fund', 'River Capital', 'British Design Fund', 'Deepbridge', 'Foresight', 'Northern Gritstone'];

const HomeLogoStrip = () => (
    <section className="lp-logos-sec">
        <p className="lp-logos-eyebrow">Trusted by 50+</p>
        <h2 className="lp-logos-title">Our Partners</h2>
        <div className="lp-logos-strip">
            <div className="lp-logos-track">
                {[...PARTNERS, ...PARTNERS].map((name, i) => (
                    <span className="lp-logo-chip" key={i}>{name}</span>
                ))}
            </div>
        </div>
    </section>
);

export default HomeLogoStrip;
